import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "initials", "frame", "src", "alt", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import classNames from 'classnames';
import DixuImage from "../DixuImage/DixuImage";
import { toRem } from "../../utils/Utils";
import DixuText from "../DixuText/DixuText";
const DixuAvatar = _ref => {
  let {
      size,
      initials,
      frame,
      src,
      alt,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-avatar', {
    'dixu-avatar--frame': typeof frame === 'undefined' ? !!initials : frame
  }, className);
  const formattedInitials = initials?.slice(0, 3).toUpperCase();
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes,
    style: {
      width: toRem(size)
    }
  }, rest), formattedInitials && /*#__PURE__*/React.createElement("div", {
    className: 'dixu-avatar__initials-wrapper'
  }, /*#__PURE__*/React.createElement("div", {
    className: "dixu-avatar__initials"
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "5",
    color: "2-7",
    align: "center",
    weight: "bold"
  }, formattedInitials))), !formattedInitials && /*#__PURE__*/React.createElement(DixuImage, {
    src,
    alt,
    type: 'circle'
  }));
};
DixuAvatar.defaultProps = {
  size: 80,
  initials: undefined,
  frame: undefined
};
export default DixuAvatar;